
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook that forces refresh of meta tags on route changes
 * This helps ensure social media platforms pick up the correct image when links are shared
 */
export function useForceRefresh() {
  const location = useLocation();
  
  useEffect(() => {
    console.log(`Route loaded: ${location.pathname}`);
    
    // Force refresh of all meta tags by re-setting their attributes
    setTimeout(() => {
      // Handle Open Graph meta tags
      const ogTags = document.querySelectorAll('meta[property^="og:"]');
      ogTags.forEach(tag => {
        const property = tag.getAttribute('property');
        const content = tag.getAttribute('content');
        if (property && content) {
          // Remove and re-add to force browsers to recognize the change
          tag.removeAttribute('property');
          tag.setAttribute('property', property);
          tag.removeAttribute('content');
          tag.setAttribute('content', content);
          console.log(`Refreshed OG tag: ${property} = ${content}`);
        }
      });
      
      // Handle Twitter meta tags
      const twitterTags = document.querySelectorAll('meta[name^="twitter:"]');
      twitterTags.forEach(tag => {
        const name = tag.getAttribute('name');
        const content = tag.getAttribute('content');
        if (name && content) {
          // Remove and re-add to force browsers to recognize the change
          tag.removeAttribute('name');
          tag.setAttribute('name', name);
          tag.removeAttribute('content');
          tag.setAttribute('content', content);
          console.log(`Refreshed Twitter tag: ${name} = ${content}`);
        }
      });
      
      console.log("Meta tags refreshed for social sharing");
    }, 100); // Small delay to ensure DOM is ready
  }, [location.pathname]);
}
